"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mostOccuringType = exports.countByType = exports.isValidUUIDv4 = exports.isValidIoTVeui = exports.isValidLoRaAppKey = exports.isValidLoRaEui = exports.CommonRegexMap = exports.checkStdProcessEnvs = exports.HttpStatus = exports.CRUD = exports.AdjacentType = exports.GraphType = exports.TimestampType = exports.AppValueTypes = exports.FEATURE_ON_OFF = exports.isRunningInVPC = exports.DataLifeCyclePeriod = exports.isTimePeriod = exports.getEnumShape = exports.getOverlapLength = exports.EnabledDisabled = exports.Milliseconds = void 0;
const Validation_1 = require("./Validation");
const millisecond = 1;
const second = 1000 * millisecond;
const minute = 60 * second;
const hour = 60 * minute;
const day = 24 * hour;
const daysInWeek = 7;
var Milliseconds;
(function (Milliseconds) {
    Milliseconds[Milliseconds["SECOND"] = 1000] = "SECOND";
    Milliseconds[Milliseconds["MINUTE"] = 60000] = "MINUTE";
    Milliseconds[Milliseconds["HOUR"] = 3600000] = "HOUR";
    Milliseconds[Milliseconds["DAY"] = 86400000] = "DAY";
})(Milliseconds || (exports.Milliseconds = Milliseconds = {}));
exports.EnabledDisabled = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
};
/**
 * @function getOverlapLength gets the number length overlap between two number ranges, returns 0 when the internal max min give -negative which indicates no overlap
 * @param param0
 * @returns
 */
const getOverlapLength = ([referenceRange, comparedRange]) => Math.max(0, Math.min(referenceRange[1], comparedRange[1]) - Math.max(referenceRange[0], comparedRange[0]));
exports.getOverlapLength = getOverlapLength;
const getEnumShape = (arr) => {
    return arr.reduce((acc, curr) => {
        acc[curr] = curr;
        return acc;
    }, {});
};
exports.getEnumShape = getEnumShape;
/** checks timestamps are numbers and in asc order */
const isTimePeriod = (x) => {
    const c = x;
    return !!c && (0, Validation_1.isNonNaNNumber)(c.fromDateMs) && (0, Validation_1.isNonNaNNumber)(c.toDateMs) && c.fromDateMs <= c.toDateMs;
};
exports.isTimePeriod = isTimePeriod;
var DataLifeCyclePeriod;
(function (DataLifeCyclePeriod) {
    DataLifeCyclePeriod["DEVICE_PERIOD"] = "DEVICE_PERIOD";
    DataLifeCyclePeriod["DAILY"] = "DAILY";
    DataLifeCyclePeriod["WEEKLY"] = "WEEKLY";
    DataLifeCyclePeriod["MONTHLY"] = "MONTHLY";
    DataLifeCyclePeriod["QUARTERLY"] = "QUARTERLY";
    DataLifeCyclePeriod["YEARLY"] = "YEARLY";
})(DataLifeCyclePeriod || (exports.DataLifeCyclePeriod = DataLifeCyclePeriod = {}));
/** returns true if the IoTV indicator AWS_LAMBDA_FUNCTION_VPC_ID is present in process.env. This means that the execution is inside a vpc */
exports.isRunningInVPC = !!process.env?.AWS_LAMBDA_FUNCTION_VPC_ID;
var FEATURE_ON_OFF;
(function (FEATURE_ON_OFF) {
    FEATURE_ON_OFF["ON"] = "on";
    FEATURE_ON_OFF["OFF"] = "off";
})(FEATURE_ON_OFF || (exports.FEATURE_ON_OFF = FEATURE_ON_OFF = {}));
var AppValueTypes;
(function (AppValueTypes) {
    AppValueTypes["NUMBER"] = "number";
    AppValueTypes["DATE"] = "date";
    AppValueTypes["STRING"] = "string";
    AppValueTypes["BOOLEAN"] = "boolean";
    AppValueTypes["ENUM"] = "enum";
    AppValueTypes["TIMESTAMP_MS"] = "TIMESTAMP_MS";
    AppValueTypes["TIMESTAMP_SEC"] = "TIMESTAMP_SEC";
    AppValueTypes["TIMESTAMP_STRING_SEC"] = "TIMESTAMP_STRING_SEC";
    AppValueTypes["OBJECT"] = "object";
})(AppValueTypes || (exports.AppValueTypes = AppValueTypes = {}));
var TimestampType;
(function (TimestampType) {
    TimestampType[TimestampType["STRING"] = 0] = "STRING";
    TimestampType[TimestampType["NUMBER"] = 1] = "NUMBER";
})(TimestampType || (exports.TimestampType = TimestampType = {}));
var GraphType;
(function (GraphType) {
    GraphType["NODE"] = "NODE";
    GraphType["EDGE"] = "EDGE";
})(GraphType || (exports.GraphType = GraphType = {}));
var AdjacentType;
(function (AdjacentType) {
    AdjacentType["PARENT"] = "matchedRelatedByPk";
    AdjacentType["CHILD"] = "matchedRelatedBySk";
    AdjacentType["SUBJECT"] = "matchedPrimary";
})(AdjacentType || (exports.AdjacentType = AdjacentType = {}));
var CRUD;
(function (CRUD) {
    CRUD["CREATE"] = "CREATE";
    CRUD["READ"] = "READ";
    CRUD["UPDATE"] = "UPDATE";
    CRUD["DELETE"] = "DELETE";
})(CRUD || (exports.CRUD = CRUD = {}));
var HttpStatus;
(function (HttpStatus) {
    HttpStatus[HttpStatus["OK"] = 200] = "OK";
    HttpStatus[HttpStatus["NO_CONTENT"] = 204] = "NO_CONTENT";
    HttpStatus[HttpStatus["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpStatus[HttpStatus["NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpStatus[HttpStatus["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HttpStatus[HttpStatus["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    HttpStatus[HttpStatus["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
})(HttpStatus || (exports.HttpStatus = HttpStatus = {}));
/** Checks NON UI process.envs for completeness, this can only be used in code that does not run in React UIs */
const checkStdProcessEnvs = () => {
    const { projectCode, stage, AWS_DEFAULT_REGION, accountId, projectName, AWS_PROFILE } = process.env;
    const undefinedEnvVars = Object.entries({ projectCode, stage, AWS_DEFAULT_REGION, accountId, projectName, AWS_PROFILE }).reduce((a, [ck, cv]) => {
        if (!(typeof cv === 'string'))
            a.push(ck);
        return a;
    }, []);
    if (undefinedEnvVars.length > 0) {
        throw new Error(`The following environment variables are not set ${undefinedEnvVars.join(', ')}`);
    }
    else {
        console.log({ projectCode, stage, AWS_DEFAULT_REGION, accountId, projectName, AWS_PROFILE });
    }
};
exports.checkStdProcessEnvs = checkStdProcessEnvs;
/** Common enforceable regex
 * must be used like: new RegExp(CommonRegexMap.IoTV.eui)
 */
exports.CommonRegexMap = {
    LoRa: {
        eui: /^([0-9a-fA-F]{2}){8}$/,
        appKey: /^([0-9a-fA-F]{2}){16}$/,
    },
    IoTV: {
        eui: /^([0-9A-F]{2}){8}$/,
    },
    UUID: {
        v4: /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/,
    },
};
/** test for 8 byte hex */
const isValidLoRaEui = (s) => !!s && typeof s === 'string' && new RegExp(exports.CommonRegexMap.LoRa.eui).test(s);
exports.isValidLoRaEui = isValidLoRaEui;
/** test for 16 byte hex */
const isValidLoRaAppKey = (s) => !!s && new RegExp(exports.CommonRegexMap.LoRa.appKey).test(s);
exports.isValidLoRaAppKey = isValidLoRaAppKey;
/** test for 8 byte uppercase hex */
const isValidIoTVeui = (s) => !!s && new RegExp(exports.CommonRegexMap.IoTV.eui).test(s);
exports.isValidIoTVeui = isValidIoTVeui;
const isValidUUIDv4 = (s) => !!s && new RegExp(exports.CommonRegexMap.UUID.v4).test(s);
exports.isValidUUIDv4 = isValidUUIDv4;
const countByType = (obs) => {
    const map = {};
    const typeMap = (obs.reduce((a, ob) => {
        const { type } = ob;
        if (!a[type])
            a[type] = 0;
        a[type]++;
        return a;
    }, map));
    const ascOccurenceMap = Object.fromEntries(Object.entries(typeMap).sort(([k1, v1], [k2, v2]) => v1 - v2));
    return ascOccurenceMap;
};
exports.countByType = countByType;
const mostOccuringType = (obs) => {
    const ascOccurenceMap = (0, exports.countByType)(obs);
    const lastKey = Object.keys(ascOccurenceMap)[Object.keys(ascOccurenceMap).length - 1];
    return lastKey;
};
exports.mostOccuringType = mostOccuringType;
